import { render, staticRenderFns } from "./RzoPowerStats.vue?vue&type=template&id=d18f1dc2&"
import script from "./RzoPowerStats.vue?vue&type=script&lang=js&"
export * from "./RzoPowerStats.vue?vue&type=script&lang=js&"
import style0 from "./RzoPowerStats.vue?vue&type=style&index=0&id=d18f1dc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RzoPowerStats.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports